import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./containers/App";

import { runWithAdal } from "react-adal";
import { authContext } from "./services/auth";

// true: bootstrap never calls login() itself. All sign-in goes through the
// guarded path in Home (one interactive attempt per session) — with false,
// a redirect returning without a cached token loops here before Home mounts.
const DO_NOT_LOGIN = true;

runWithAdal(
  authContext,
  () => {
    ReactDOM.render(<App />, document.getElementById("root"));
  },
  DO_NOT_LOGIN
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
